import { format, parse } from 'date-fns';

export function formatAmPmTime(input: string): string {
  const date = parse(input, 'HH:mm', new Date());
  return format(date, 'hh:mm a');
}
